export default __webpack_public_path__ + "static/media/Airswap.8e14a79d.svg";